import { neon } from '@/services/neon'

export async function auditLog(
  userId: string | undefined,
  table: string,
  recordId: string,
  action: 'create' | 'update' | 'delete',
  changes?: Record<string, { from?: any; to?: any }>,
): Promise<void> {
  try {
    await neon.from('audit_logs').insert({
      user_id: userId || null,
      table_name: table,
      record_id: recordId,
      action,
      changes: changes || {},
    })
  } catch {
    // silently fail — audit logging should never break the app
  }
}
